module.exports = __webpack_public_path__ + "img/amx-3.c81aac0e.webp";